export const info={
  siteId: "2b143042-85e1-4edb-be93-ddfc87905275",
  organizationId: "c376c8fb-ed5b-418f-acd9-b9e02f6b8ff6",
}

export const defaultInfo={
  organization:{
    name:"Fresh Food Manufacturing Sdn Bhd",
    id:"c376c8fb-ed5b-418f-acd9-b9e02f6b8ff6"
  },
  superAdmin:{
   name:"SuperAdmin",
   id:"a5e318f0-825c-43be-8b7a-4998c9c2f467"
  },
  administrator:{
    name:"Administrator",
    id:"dbf36f36-efc7-4fd0-985c-396acb561dde"
  },
  OrgAdmin:{
    id:"944ff090-990e-46bc-a955-038a61c5b0eb",
    name:"Ora Admin"
  },
  site:{
    id:"2b143042-85e1-4edb-be93-ddfc87905275",
    siteName:"Shah Alam123"
  },
   workType:{
    CM:"CM01",
    EM:"EM01",
    PM:"PM01",
    PM_INS:"PM-INS01",
    OPERATION:"OPS",
    FACILITY:"FAC",
   }
}

export const SubMenu={
    woTask:"cddc3c1a-ead8-4da1-8d86-9d334a249e95",
    woLabour:"ed9222a6-7f75-46cb-bf03-3553ddfe9de4",
    woPart:"b3848227-c74d-4198-b580-5a9cb2c1441e",
    workFlowApproval:"6006bb5d-a001-48c9-9d88-e878d585be75",
    partReservation:"4accbc53-c8c6-46f1-84ee-35b37c9effae",
}
